import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUpdatePolygonActions from "../../store/actions/BulkUpdatePolygon";
import BulkUploadFile from "../BulkUploadFile";

//change
const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = ({ getUploadUrl }) => {

  return (
    <BulkUpdatePolygonModal>
       <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BulkUpdatePolygonActionsUpload"
        uploadUrl="/polygon/bulk-update/ack"
        sampleURL="/sample/bulk_update_polygon.csv"
        id="bulkUpdatePolygonModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Update Polygon"
        useUserUploadedFilename={true}
        getUploadUrl={getUploadUrl}
        validationType="BulkUpdatePolygon"
        maxSize={0.5} // in mb
      />
    </BulkUpdatePolygonModal>
  );
};

const BulkUpdatePolygonModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUpdatePolygonActions.bulkUpdatePolygon,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);